import { withDragAndDropProvider } from 'contexts/dragAndDropProvider';
import MediaGrid from 'components/MediaGrid';

const MediaManagerListPage = () => {
  return <MediaGrid title="Gerenciamento de Mídias" />;
};

export default withDragAndDropProvider(MediaManagerListPage);
